import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { isProduction } from '@masfront/common-core'

import { setQueryParams } from '../store/router.reducer'

import { filterFalsyValues } from '~/core/helpers/helpers'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { INVALID_QUERY_PARAMS, NO_BRAND } from '~/modal/constants/messages'
import useModal from '~/modal/hooks/useModal'
import ModalMessages from '~/modal/models/modal.model'

interface useSalesQueryParamsReturn {
  brand: string
  documentType: string
  documentValue: string
  contractId: string
}

export default function useSalesQueryParams(): useSalesQueryParamsReturn {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const { selectAndOpenModalFromList } = useModal()
  const { runtimeConfig } = useAppDepsContext()

  const queryParams = new URLSearchParams(search)

  const brand = queryParams?.get('brand') || ''
  const documentType = queryParams?.get('documentType') || ''
  const document = queryParams?.get('document') || ''
  const accountNumber = queryParams?.get('accountNumber') || ''

  const salesQueryParamMessages: ModalMessages = {
    NO_BRAND: {
      open: false,
      title: NO_BRAND.title,
      description: NO_BRAND.description,
      actions: [
        {
          button: { variant: 'contained', size: 'medium', color: 'secondary' },
          name: NO_BRAND.actions.continue,
          dataHook: 'continue-client-search',
        },
      ],
      type: 'warning',
    },
    INVALID_QUERY_PARAMS: {
      open: false,
      title: INVALID_QUERY_PARAMS.title,
      description: INVALID_QUERY_PARAMS.description,
      actions: [
        {
          button: { variant: 'contained', size: 'medium', color: 'secondary' },
          name: INVALID_QUERY_PARAMS.actions.continue,
          dataHook: 'continue-client-search',
        },
      ],
      type: 'warning',
    },
  }

  useEffect(() => {
    if (!brand && isProduction(runtimeConfig.environment)) {
      selectAndOpenModalFromList('NO_BRAND', salesQueryParamMessages)
    }
    if (
      brand &&
      ((documentType && !document) ||
        (document && !documentType) ||
        (accountNumber && ((documentType && !document) || (document && !documentType))))
    )
      selectAndOpenModalFromList('INVALID_QUERY_PARAMS', salesQueryParamMessages)

    dispatch(setQueryParams(filterFalsyValues({ brand, documentType, document, accountNumber })))
  }, [brand, documentType, document, accountNumber])

  return {
    brand,
    documentType,
    documentValue: document,
    contractId: accountNumber,
  }
}
